import {
  CHANGE_COMPACT_MODE,
  CHANGE_DIRECTION,
  CHANGE_NAVIGATION_STYLE,
  DARK_THEME,
  DRAWER_TYPE,
  FIXED_DRAWER,
  HORIZONTAL_MENU_POSITION,
  INSIDE_THE_HEADER,
  SWITCH_LANGUAGE,
  THEME_COLOR,
  TOGGLE_COLLAPSED_NAV,
  VERTICAL_NAVIGATION,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
} from 'constants/ActionTypes';
import { DARK_GREEN } from 'constants/ThemeColors';
import {
  CHANGE_CURRENT_SHOP,
  CHANGE_CURRENT_APP,
} from '../constants/ActionTypes';
import { getStoredLocale, setStoredLocale } from '../util/localeStorage';

const rltLocale = ['ar'];

const initialSettings = {
  currentShop: null,
  navCollapsed: false,
  drawerType: FIXED_DRAWER,
  themeColor: DARK_GREEN,
  darkTheme: false,
  width: window.innerWidth,
  height: window.innerHeight,
  isDirectionRTL: false,
  isCompactMode: false,
  navigationStyle: VERTICAL_NAVIGATION,
  horizontalNavPosition: INSIDE_THE_HEADER,
  locale: getStoredLocale(),
};

const app = (state = initialSettings, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        navCollapsed: false,
      };

    case CHANGE_CURRENT_SHOP:
      return {
        ...state,
        currentShop: action.payload,
      };

    case CHANGE_CURRENT_APP:
      return {
        ...state,
        currentApp: action.payload,
      };

    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed,
      };
    case DRAWER_TYPE:
      return {
        ...state,
        drawerType: action.drawerType,
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case WINDOW_HEIGHT:
      return {
        ...state,
        height: action.height,
      };
    case THEME_COLOR:
      return {
        ...state,
        darkTheme: false,
        themeColor: action.color,
      };
    case DARK_THEME:
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    case SWITCH_LANGUAGE:
      setStoredLocale(action.payload);

      return {
        ...state,
        locale: action.payload,
        isDirectionRTL: rltLocale.includes(action.payload.locale),
      };
    case CHANGE_DIRECTION:
      return {
        ...state,
        isDirectionRTL: !state.isDirectionRTL,

      };

    case CHANGE_COMPACT_MODE:
      return {
        ...state,
        isCompactMode: action.payload,
      };

    case CHANGE_NAVIGATION_STYLE:
      return {
        ...state,
        navigationStyle: action.payload,
      };

    case HORIZONTAL_MENU_POSITION:
      return {
        ...state,
        horizontalNavPosition: action.payload,
      };

    default:
      return state;
  }
};

export default app;
